// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"22808f2d","165":"7dc72fc4","444":"fe5a6e6b","453":"c5f0a7ff","609":"45b1a2f9","754":"9021ba68","774":"ccb46435","796":"0e6d6425","884":"de7f8314"}[chunkId] + ".chunk.js";
};